<template>
  <div class="w-100">
    <!-- Navigation and related information START -->
    <div id="nav-info" role="navigation" class="container-fluid fixed-top w-100 px-0 background-white" style="z-index: 10;">
      <interview-navi :navData="pageData"></interview-navi>
    </div>
    <div role="main" :class="{'quote-panel-open': quotePanelStatus, 'quote-panel-close': !quotePanelStatus}">
    <!-- REQUIRED-->
    <div class="required"></div>
    <div class="container page-wrap">
     <div class="row no-gutters mx-0 my-3">
      <div class="col-9">
      <div class="alert alert-warning alert-dismissible fade show b-alert-warning" role="alert" v-if="complete && nocarrierAlert">
        <div class="text-div">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
            <path d="M28 14C28 21.7337 21.7314 28 14 28C6.26856 28 0 21.7337 0 14C0 6.27082 6.26856 0 14 0C21.7314 0 28 6.27082 28 14ZM14 16.8226C12.5658 16.8226 11.4032 17.9852 11.4032 19.4194C11.4032 20.8535 12.5658 22.0161 14 22.0161C15.4342 22.0161 16.5968 20.8535 16.5968 19.4194C16.5968 17.9852 15.4342 16.8226 14 16.8226ZM11.5346 7.48853L11.9533 15.166C11.9729 15.5252 12.27 15.8065 12.6298 15.8065H15.3703C15.73 15.8065 16.0271 15.5252 16.0467 15.166L16.4654 7.48853C16.4866 7.10049 16.1776 6.77419 15.789 6.77419H12.2109C11.8223 6.77419 11.5134 7.10049 11.5346 7.48853Z" fill="#EAAA00"/>
          </svg>
          <span class="ml-3" v-html="nocarrierAlertMsg"></span>
        </div>
      </div>
      <!-- TOP Instruction SECTION -->
      <div class="d-flex justify-content-center mx-auto mt-3 mb-1" v-if="blurbs.formtop && blurbs.formtop.visible">
        <div class="alert alert-primary my-0 py-2 w-100" role="note">
          <div class="row no-gutters">
            <div class="d-inline-block pr-2 my-auto">
              <img width="25px" height="25px" src="../../../assets/info-circle-blue.svg" alt="info">
            </div>
            <div class="col d-inline-block my-auto smaller-font-content"  v-html="blurbs.formtop.content">
            </div>
          </div>
        </div>
      </div>
      <!-- TOP Instruction SECTION END -->
        </div>
      <div class="col-3"  v-if="!(isHomeBound && isAutoBound) && appointedCarrierStatus">
        <div class="smaller-text-secondary text-right" >Last updated {{lastRC1DateTimeString}}</div>
        <button type="button" tabindex="0"  class="btn btn-primary float-right refreshButton mb-2"  role="button" @click="refreshRates()"><i  class="fas">&#xf01e;</i>&nbsp;Refresh Rates</button>
       </div>
     </div>
      <div id="carrier-results" class="row no-gutters mx-0 my-3">
        <div class="col-12">
          <div>
            <div class="row mx-0">
              <div class="col-12 px-0">
              <!-- Carrier Components BEGIN -->

                <!--CARRIER RESULTS TABLE START-->
                <div id="results-table" class="container">
                  <div class="row" v-show="complete && carrierSuccessArray.length > 0">
                    <div class="col-9">
                      <!--Results Header START-->
                      <div id="results-head" class="row smaller-font-content font-weight-bold border-bottom border-bottom-carriers bg-white">
                          <!--Carrier Column-->
                          <a class="col-3 col-head my-auto" href="JavaScript:void(0);" :class="{ selected: sortKey === 'home' }" @click.prevent="sort('home')" v-if="flowType == 'bundle'">
                            Home
                          </a>
                          <a class="col-3 col-head my-auto" href="JavaScript:void(0);" :class="{ selected: sortKey === 'condo' }" @click.prevent="sort('condo')" v-if="flowType == 'cabundle'">
                            Condo
                          </a>
                          <a class="col-3 col-head my-auto" href="JavaScript:void(0);" :class="{ selected: sortKey === 'renters' }" @click.prevent="sort('renters')" v-if="flowType == 'rabundle'">
                            Renters
                          </a>
                          <!--Monthly Payment Column-->
                          <a class="col-3 col-head my-auto" href="JavaScript:void(0);" :class="{ selected: sortKey === 'auto' }" @click.prevent="sort('auto')">
                            Auto
                          </a>
                          <!--Total Payment Column-->
                          <a class="col-3 col-head my-auto" href="JavaScript:void(0);" :class="{ selected: sortKey === 'all' }" @click.prevent="sort('all')">
                            All Quotes
                          </a>
                          <!--Button Column-->
                          <div class="col-3">
                          </div>
                      </div>
                      <!--Results Header END-->
                    </div>
                    <div class="col-3 position-relative export-dropdown-col p-0">
                      <input-select :fieldData="exportDropdown" :ref="exportDropdown.field_name" :exportPDF="exportPDF"></input-select>
                    </div>
                  </div>

                  <!--Progress Bar START-->
                  <div v-show="carrierCount > 0 && showProgressBar === true" class="row progress shadow-sm rounded-0 mb-3">
                    <div class="progress-bar progress-bar-striped progress-bar-animated bg-warning text-dark text-center bold px-3" :ref="'progress_bar'" role="progressbar" aria-valuemin="0" aria-valuemax="100" style="width: 0%;">Retrieving Quotes...</div>
                  </div>
                  <!--Progress Bar END-->
                  <carrier-success v-for="(carrier, cKey) in carrierSuccessArray" :key="cKey+'_carKey'" :carrier='carrier' :carCount = cKey v-if="sortKey === 'all' || sortKey===carrier.carrierType"></carrier-success>
                </div>
                <!-- Knockout Beginning -->
                <div id="knockout-wrap" class="col-12" v-show="carrierErrorArray.length > 0 && complete">
                  <!--KNOCKOUT SECTION HEADER-->
                  <div class="row mt-3">
                    <div class="col-12 py-2 bg-greyed text-white rounded-top">
                      <strong>Carrier Knockouts</strong>
                      <div class="smaller-font-content">The following carrier(s) were unable to return a quote with the provided customer information.</div>
                    </div>
                  </div>
                  <!--KNOCKOUT SECTION HEADER-->
                  <carrier-failure v-for="(carrier, fKey) in carrierErrorArray" :key="fKey+'_failKey'" :carrier='carrier' :carCountFail = fKey></carrier-failure>
                </div>
                <div class="col-12 text-center text-secondary my-4" v-if="carrierSuccessArray.length === 0 && carrierErrorArray.length === 0 && complete">
                  <h3>No Carriers Found.</h3>
                  <p>There are no returned carrier matches. This could be caused by a failed system response.</p>
                </div>
                <!-- Carrier Components END -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!appointedCarrierStatus" class="row col-12">
        <div class="text-center col-md-12 appt-error-msg">You&#39;re not appointed by any carriers in this state.</div>
      </div>
    </div>
</div>
<div class="blank-space" v-if="selectedHomeCarrier || selectedAutoCarrier"></div>
<dev-auto-fill :pageData="pageData"></dev-auto-fill>
<!-- Bound Policy Alert -->
<form-alerts v-if="isHomeBound && isAutoBound" :pageData="policyBindError" :class="{'policy-bound-alert': true, 'margin-25' : quotePanelStatus}"></form-alerts>
<!--- Bundle Flow Selected Carriers box -->
<div :class="{'selected-carrier-bottom-container': true, 'margin-25' : quotePanelStatus}" v-if="(selectedHomeCarrier || selectedAutoCarrier) && !(isHomeBound && isAutoBound)">
  <div class="container">
    <div class="row no-gutters mx-0 my-3 d-flex align-items-center px-3">
      <div class="col-12 same-carrier-bundle-discount" v-if="sameCarrierBundleDiscount">
        <div class="alert alert-primary" role="alert">
          <i class="fas circle-icon-info mr-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
              <path d="M16.0003 29.8979C23.3337 29.8979 29.3337 23.8979 29.3337 16.5645C29.3337 9.2312 23.3337 3.2312 16.0003 3.2312C8.66699 3.2312 2.66699 9.2312 2.66699 16.5645C2.66699 23.8979 8.66699 29.8979 16.0003 29.8979ZM14.667 9.89787H17.3337V12.5645H14.667V9.89787ZM18.667 23.2312H13.3337V20.5645H14.667V17.8979H13.3337V15.2312H17.3337V20.5645H18.667V23.2312Z" fill="#003366"/>
            </svg>
          </i><strong>Potential Savings:</strong> The biggest discounts are most likely when you bundle <span v-if="flowType == 'bundle'">home</span><span v-if="flowType == 'cabundle'">condo</span><span v-if="flowType == 'rabundle'">renters</span> and auto with the same carrier.
        </div>
      </div>
      <div class="col-3 summary-col">
        <p>Insurance Summary</p>
        <div class="">
          <select class="form-select select-dropbox" v-model="policyTerm">
              <!-- <option value="">Select One</option> -->
              <option v-for="(termData, tkey) in termArr" :key="tkey" :value="tkey"> {{ termData }}</option>
          </select>
        </div>
        <p><i class="icon-star">*</i> Payment options will be finalized at checkout</p>
      </div>
      <div class="col-3 text-center" :class="{'disabled bound-carrier' : isHomeBound}">
        <div class="select-auto-carrier" v-if="!selectedHomeCarrier">Select <span v-if="flowType == 'bundle'">Home</span><span v-if="flowType == 'cabundle'">Condo</span><span v-if="flowType == 'rabundle'">Renters</span> Coverage to create a bundle</div>
        <div class="selected-home-carrier" v-else>
          <div class="bundle-carrier-logo">
            <img :src="selectedHomeCarrier.logoPathSvg" :alt="selectedHomeCarrier.carrier_name"/>
            <span class="bundle-coverage-text ml-2 pl-2"><span v-if="flowType == 'bundle'">Home</span><span v-if="flowType == 'cabundle'">Condo</span><span v-if="flowType == 'rabundle'">Renters</span> Coverage</span>
          </div>
          <div class="bundle-carrier-premium" v-if="policyTerm === 'm' && selectedHomeCarrier.monthly_premium !== null">
            <div>{{ selectedHomeCarrier.monthly_premium | currency-filter }} <span>/Month</span></div>
          </div>
          <div class="bundle-carrier-premium discounted" v-else v-show="selectedHomeCarrier.premium_amount !== null">
            <div><span class="save">Save {{ selectedHomeCarrier.payinfull_discount | currency-filter }}</span></div>
            <div><span class="line-through">{{ selectedHomeCarrier.premium_amount | currency-filter }}</span> {{ selectedHomeCarrier.payinfull_amount | currency-filter }} <span class="quoteTerm"><span class="text-capitalize">Full</span> {{ selectedHomeCarrier.policy_term }}</span></div>
          </div>
        </div>
      </div>
      <div class="col-3 text-center" :class="{'disabled bound-carrier' : isAutoBound}">
        <div class="row align-items-center no-gutters">
          <div class="col-1"><i class="fa fa-plus"></i></div>
          <div class="col-11">
            <div class="select-auto-carrier" v-if="!selectedAutoCarrier">Select Auto Coverage to create a bundle</div>
            <div class="selected-auto-carrier" v-else>
              <div class="bundle-carrier-logo">
                <img :src="selectedAutoCarrier.logoPathSvg" :alt="selectedAutoCarrier.carrier_name"/>
                <span class="bundle-coverage-text ml-2 pl-2">Auto Coverage</span>
              </div>
              <div class="bundle-carrier-premium" v-if="policyTerm === 'm' && selectedAutoCarrier.monthly_premium !== null">
                <div>{{ selectedAutoCarrier.monthly_premium | currency-filter }}  <span>/Month</span></div>
              </div>
              <div class="bundle-carrier-premium discounted" v-else v-show="selectedAutoCarrier.premium_amount !== null">
                <div><span class="save">Save {{ selectedAutoCarrier.payinfull_discount | currency-filter }}</span></div>
                <div><span class="line-through">{{ selectedAutoCarrier.premium_amount | currency-filter }}</span> {{ selectedAutoCarrier.payinfull_amount | currency-filter }} <span class="quoteTerm"><span class="text-capitalize">Full</span> {{ selectedAutoCarrier.policy_term }}</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-3 px-1 my-auto text-center">
        <div class="bundle-carrier-premium total" v-if="policyTerm === 'm'">
          {{ calculateBundlePremiumAmount | currency-filter }}<span class="quoteTerm">/Month</span>
        </div>
        <div class="bundle-carrier-premium discounted" v-else>
          <div>{{ calculateBundlePremiumAmount | currency-filter }}
            <span class="quoteTerm"  v-if="selectedHomeCarrier && selectedAutoCarrier"> {{ selectedHomeCarrier.policy_term }}</span>
            <span class="quoteTerm"  v-else-if="selectedHomeCarrier"> {{ selectedHomeCarrier.policy_term }}</span>
            <span class="quoteTerm"  v-else-if="selectedAutoCarrier"> {{ selectedAutoCarrier.policy_term }}</span>
          </div>
          <div><span class="save align-top">Save {{ calculateBundleDiscount | currency-filter }}</span></div>
        </div>
        <div class="button-row">
          <button type="button" tabindex="0" :id="`select-carrier-btn`" class="btn btn-primary select-carrier-btn mb-2" @click="openRc2Flow()" role="button">Save & Continue</button>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
</template>

<script>
/* eslint-disable */

/**
 * Carrier Matches Interview page is the last step in the Interview process. All the information from the preceding pages is used
 * to display quotes from different Insurance Carriers.
 *
 * To see the info sent from the server to render everything EXCEPT carrier info, find 'fetchData.getPageData' and log to console the response.
 * Although this "page" response will not hold any info about Successful/Unsuccessful Carriers, it will hold all the rest of the data for the
 * page such as Help Script, Quote Summary, navigation button states, etc.
 *
 * To see server response that populates our Successful/Unsuccessful carriers area find:
 * fetchData.getCarriersData(url).then((response) => {
 * The "url" is built using the current sessionID and request is sent to the server.
 * Again, the response from the server for this request will hold all the Successful/Unsuccessful carriers.
 *
 * For each successful carrier processed, we will add to the carrierSuccessArray[]. For each unsuccessful carrier processed, we will add to
 * the carrierErrorArray[]. For each successful or unsuccessful array element we v-for through and create a child element of the page: the
 * child element will either be a <carrier-success> or <carrier-failure> child sub-component.
 *
 * The user can always go back to any previous interview page and modify values and then rerun this "Carrier Matches" page to see newly updated
 * results from all of the carriers.
 */
import InterviewNavigation from './Navigation';
import FormAlerts from '../../presentational/alerts/FormAlerts';
import InterviewNavigationTitle from './NavigationTitle';
import fetchData from '../../../services/fetchData';
import patchData from '../../../services/patchData';
import postData from '../../../services/postData';
import common from '../../../services/common';
import axios from '../../../axios-config';
import CarrierSuccess from './CarrierDetailsSuccess';
import CarrierFailure from './CarrierDetailsFailure';
import { stickyDivMixin } from '../../../mixins/stickyDivMixin';
import { pageMixin } from '../../../mixins/pageMixin';
import InputSelect from '../../interactive/InputSelect';

export default {
  mixins: [pageMixin, stickyDivMixin],
  data() {
    return {
      sessionID:'',
      flow:'',
      lastRC1DateTimeString:'',
      lastRC1DateTimeStringAuto:'',
      flowType: '',
      pageName: '',
      acarrierCount: 0,
      hcarrierCount: 0,
      // carrierCount: 0,
      showProgressBar: false,
      // appointedCarrierStatus: true, 
      carrierProcessed: 0,      
      autoCarrierLookupCnt : '',
      homeCarrierLookupCnt : '',
      complete: false,
      blurbs: {
        formtop: {
          visible: false,
          content: '',
        },
      },
      carrierSuccessArray: [],
      carrierErrorArray: [],
      sortKey: null,
      isSortedAsc: true,
      pageData: {
        page_name: '',
        buttons: [],
        fields: [],
        blurbs: [],
        quote_summary: {},
      },
      termArr: {'m' : 'Monthly Payment', 'p' : 'Pay in Full'},
      policyTerm: 'm',
      nocarrierAlertMsg: '',
      selected_home_carrier_id: '',
      selected_auto_carrier_id: '',
      isHomeCallComplete: false,
      isAutoCallComplete: false,
      exportDropdown : {
          "field_name": "QTE_PRP_ExportPDF",
          "field_type": "select_medium",
          "label": "Share Quote Summary",
          "field_value": "",
          "help_text": "",
          "sub_text": "",
          "placeholder": "Share Quote Summary",
          "visible": true,
          "is_enabled": true,
          "is_required": false,
          "rules": [],
          "values": [
              {
                  "display_value": "Print PDF",
                  "internal_value": "printpdf",
                  "visible": true,
                  "display_order": 1
              },
              // {
              //     "display_value": "Email PDF",
              //     "internal_value": "emailpdf",
              //     "visible": true,
              //     "display_order": 2
              // }
          ],
          "has_error": false,
          "error": null
      },
      carriers:[],
    };
  },
  computed: {
    appointedCarrierStatus() {
      if (this.autoCarrierLookupCnt !== '' && this.homeCarrierLookupCnt !== '') {
        return !(this.autoCarrierLookupCnt === 0 && this.homeCarrierLookupCnt === 0);
      }
      return true;
    },
    isHomeBound() {
      return sessionStorage.getItem('homebound') == 'true' ? true : false;
    },
    isAutoBound() {
      return sessionStorage.getItem('autobound') == 'true' ? true : false;
    },
    carrierCount() {
      return this.acarrierCount + this.hcarrierCount;
    },
    nocarrierAlert() {
      let homeCarrierLength = this.carrierSuccessArray.filter((carrier) => {
        return carrier.carrierType.includes('home')
      }).length;
      let condoCarrierLength = this.carrierSuccessArray.filter((carrier) => {
        return carrier.carrierType.includes('condo')
      }).length;
      let rentersCarrierLength = this.carrierSuccessArray.filter((carrier) => {
        return carrier.carrierType.includes('renters')
      }).length;
      let autoCarrierLength = this.carrierSuccessArray.filter((carrier) => {
        return carrier.carrierType.includes('auto')
      }).length;
      if (this.flowType === 'cabundle') {
        if (condoCarrierLength === 0 && autoCarrierLength !== 0) {
          this.nocarrierAlertMsg = '<strong>No Condo Carriers matched:</strong> The information you supplied did not match to any current Condo carriers.';
          return true;
        } else if (condoCarrierLength !== 0 && autoCarrierLength === 0) {
          this.nocarrierAlertMsg = '<strong>No Auto Carriers matched:</strong> The information you supplied did not match to any current Auto carriers.';
          return true;
        }
      } else if (this.flowType === 'rabundle') {
        if (rentersCarrierLength === 0 && autoCarrierLength !== 0) {
          this.nocarrierAlertMsg = '<strong>No Renters Carriers matched:</strong> The information you supplied did not match to any current Renters carriers.';
          return true;
        } else if (rentersCarrierLength !== 0 && autoCarrierLength === 0) {
          this.nocarrierAlertMsg = '<strong>No Auto Carriers matched:</strong> The information you supplied did not match to any current Auto carriers.';
          return true;
        }
      } else {
        if (homeCarrierLength === 0 && autoCarrierLength !== 0) {
          this.nocarrierAlertMsg = '<strong>No Home Carriers matched:</strong> The information you supplied did not match to any current Home carriers.';
          return true;
        } else if (homeCarrierLength !== 0 && autoCarrierLength === 0) {
          this.nocarrierAlertMsg = '<strong>No Auto Carriers matched:</strong> The information you supplied did not match to any current Auto carriers.';
          return true;
        }
      }
      
      return false;
    },
    sameCarrierBundleDiscount() {
      if (this.selectedHomeCarrier && this.selectedAutoCarrier) {
        return this.selectedHomeCarrier.carrier_id !== this.selectedAutoCarrier.carrier_id;
      }
      return false;
    },
    calculateBundleDiscount() {
      let home_payinfull_discount = 0;
      let auto_payinfull_discount = 0;
      if (this.selectedHomeCarrier !== null) {        
        home_payinfull_discount = this.selectedHomeCarrier.payinfull_discount === null || isNaN(this.selectedHomeCarrier.payinfull_discount) ? 0 : this.selectedHomeCarrier.payinfull_discount
      }
      if (this.selectedAutoCarrier !== null) {
        auto_payinfull_discount = this.selectedAutoCarrier.payinfull_discount === null || isNaN(this.selectedAutoCarrier.payinfull_discount) ? 0 : this.selectedAutoCarrier.payinfull_discount;
      }
      return this.policyTerm === 'm' ? 0 : parseFloat(home_payinfull_discount) + parseFloat(auto_payinfull_discount);
    },
    calculateBundlePremiumAmount() {
      let home_premium = 0;
      let auto_premium = 0;
      if (this.selectedHomeCarrier === null && this.selectedAutoCarrier === null) {
        return 0;
      }
      if (this.selectedHomeCarrier !== null) {        
        home_premium = this.policyTerm === 'm' ? this.selectedHomeCarrier.monthly_premium : this.selectedHomeCarrier.payinfull_amount;
      }
      if (this.selectedAutoCarrier !== null) {
        auto_premium = this.policyTerm === 'm' ? this.selectedAutoCarrier.monthly_premium : this.selectedAutoCarrier.payinfull_amount;
      }      
      
      home_premium = home_premium == null || isNaN(home_premium) ? 0 : home_premium;
      auto_premium = auto_premium == null || isNaN(auto_premium) ? 0 : auto_premium;
      
      return this.policyTerm === 'm' ? (parseFloat(home_premium) + parseFloat(auto_premium)) : (parseFloat(home_premium) + parseFloat(auto_premium));// - parseFloat(home_payinfull_discount) - parseFloat(auto_payinfull_discount));
    },
    selectedHomeCarrier() {
      return this.$store.getters.getSelectedHomeCarrier;
    },
    selectedAutoCarrier() {      
      return this.$store.getters.getSelectedAutoCarrier;
    },
  },
  components: {
    interviewNavi: InterviewNavigation,
    carrierSuccess: CarrierSuccess,
    carrierFailure: CarrierFailure,
    interviewNaviTitle: InterviewNavigationTitle,
    FormAlerts,
    InputSelect
  },
  methods: {
     refreshRates(){
      this.complete=false;
      this.showProgressBar = false;
      this.carrierProcessed=0;
      this.carrierSuccessArray=[];
      this.carrierErrorArray=[];
      /* HOME Rate call rates API start here with {forceNewRateCall}=true */
      const apiURL = `/carriers/${this.sessionID}/true`;
      /**
       * Our Call to retrieve different rates for all carriers
       */
      fetchData.getCarriersData(apiURL).then((response2) => {
        this.lastRC1DateTimeString=response2.data.lastRC1DateTimeString;
        this.showProgressBar = true;
        this.updateProgressBarOnRefresh();
        this.processCarriersMultipleCalls(response2, this.flow);
        this.isHomeCallComplete = true;
      });
      /* HOME Rate call rates API End Here*/
      /* AUTO Rate call rates API start here with {forceNewRateCall}=true */
        const AUQuoteId = JSON.parse(sessionStorage.getItem('autoSessionData')).SessionId;//this.$store.getters.getSessionID;
        const AutoUrl = `/carriers/${AUQuoteId}/true`;
        /**
         * Our Call to retrieve different rates for all carriers
         */
        fetchData.getCarriersData(AutoUrl).then((response2) => {
          this.lastRC1DateTimeString=response2.data.lastRC1DateTimeString;
          this.showProgressBar = true;
          this.updateProgressBarOnRefresh();
          this.processCarriersMultipleCalls(response2, 'auto');
          this.isAutoCallComplete = true;
      });
      /* AUTO Rate call rates API End Here*/
       },
    exportPDF() {
      this.exportPDFTo(this.exportDropdown.field_value, this.carriers, 'rc1');
    },
    /**
     * Sort array by value in the array's json
     *
     * The sort buttons can be found at the very top of the Successful Carriers div. We can sort by name, pay-in-full amount or
     * montly payments.
     */
    filterArray(sortKey) {
      this.sortKey = sortKey;
      this.sort(sortKey);
    },        
    
    /**
     * Sort array by value in the array's json
     *
     * The sort buttons can be found at the very top of the Successful Carriers div. We can sort by name, pay-in-full amount or
     * montly payments.
     */
    sort(sortKey) {
      if (this.sortKey === sortKey)
        this.isSortedAsc = !this.isSortedAsc;
      else
        this.isSortedAsc = true;
      this.sortKey = sortKey;
      let isSortedAsc = this.isSortedAsc;
      function sanitizeNum(num) {
        if (num == null)
          return 0;
        return num.replace(/\,/g,'').replace(/\$/g,'');
      }
      let sortByKey = 'carrier_name';
      const compare = function (a, b) {
          let valueA = a[sortByKey];
          let valueB = b[sortByKey];
          if (isNaN(valueA))
            valueA = valueA.toUpperCase();
          else
            valueA = parseFloat(sanitizeNum(valueA));
          if (isNaN(valueB))
            valueB = valueB.toUpperCase();
          else
            valueB = parseFloat(sanitizeNum(valueB));
          if (isSortedAsc)
            return (valueA < valueB ? -1 : 1);
          else
            return (valueA > valueB ? -1 : 1);
      };
      if(sortKey!=='all'){
        this.carrierSuccessArray.sort(compare);
      } else {
        /**on selecting all quotes need to group by carrier_id**/
        /****** grouping carrierSuccessArray by carrier ids into ObjMap ****/
        let ObjMap ={};
        this.carrierSuccessArray.forEach(element => {
          var carrierID = element.carrier_id;
          if(!ObjMap[carrierID]) {
            ObjMap[carrierID] = [];
            ObjMap[carrierID].push(element);
          }else{
            ObjMap[carrierID].push(element);
          }          
        });        
        let temp1 =[];  //array to group home and auto carriers
        let temp2 =[];  //array to collect single home/auto carrier
        for (const i in ObjMap) {
          for (let j = 0; j < ObjMap[i].length; j++) { 
            if(ObjMap[i].length==2)
              temp1.push(ObjMap[i][j]);            
            else
              temp2.push(ObjMap[i][j]);
          }
        }
        if(Object.keys(temp1).length)         
          this.carrierSuccessArray =  temp1.concat(temp2);
        else
          this.carrierSuccessArray.sort(compare);
      }
    },  
    /**
     * Progress bar for when have to make multiple calls for each carrier.
     */
    updateProgressBar() {
      this.carrierProcessed += 1;
      const processedPercentage = Math.ceil((this.carrierProcessed / this.carrierCount) * 100);
      this.$refs.progress_bar.style.width = `${processedPercentage}%`;

      if ((processedPercentage === 100 || processedPercentage === '100') && this.isHomeCallComplete === true && this.isAutoCallComplete === true) {
        this.updateProgressBarStylesComplete();
        this.switchCarrierIcon();
        this.complete = true;
      }
    },
    /**
     * Progress bar for when have to make one call for all carriers.
     */
    updateProgressBarNonIncremental() {
      this.$refs.progress_bar.style.width = '100%';
      this.updateProgressBarStylesComplete();

      this.switchCarrierIcon();
      this.complete = true;
    },
    /**
     * Progress bar helper function.
     */
    updateProgressBarStylesComplete() {
      this.$refs.progress_bar.classList.add('progress-bar-bg');
      this.$refs.progress_bar.style.fontWeight = 'bold';
      this.$refs.progress_bar.style.setProperty('color', '#fff', 'important');
      this.$refs.progress_bar.innerHTML = 'All Carriers Loaded';
      this.$refs.progress_bar.classList.remove('progress-bar-animated', 'progress-bar-striped');
    },
    updateProgressBarOnRefresh(){      
      this.$refs.progress_bar.classList.add('progress-bar-animated', 'progress-bar-striped', 'text-dark');
      this.$refs.progress_bar.style.setProperty('width', '0%');
      this.$refs.progress_bar.innerHTML = 'Retrieving Quotes...';
      this.$refs.progress_bar.style.fontWeight = 'normal';
      this.$refs.progress_bar.style.setProperty('color', '#2f353a', 'important');
      this.$refs.progress_bar.classList.remove('progress-bar-bg');
    },
    /**
     * Switch the Carrier Matches Icon to compelted check-circle but we need a setTimeout() and before that set
     * property to blank string otherwise the stacked styling will be off.
     */
    switchCarrierIcon() {
      let carrierIndex;

      for (let indexTabBtns = 0; indexTabBtns < this.pageData.tab_buttons.length; indexTabBtns += 1) {
        if (this.pageData.tab_buttons[indexTabBtns].name === 'CarrierMatches') {
          carrierIndex = indexTabBtns;
        }
      }

      this.pageData.tab_buttons[carrierIndex].status = '';
      const self = this;

      const timeOut = function timeOUt() {
        self.pageData.tab_buttons[carrierIndex].status = 'ActiveComplete';
      };

      setTimeout(timeOut, 0);
    },
    /**
     * Process Multiple Carriers in Multiple Server Responses
     */
    async processCarriersMultipleCalls(response, type) {
      // this.carrierCount = response.data.carriers.length;
      if (type === 'auto') {
        this.acarrierCount = response.data.carriers.length;
        this.autoCarrierLookupCnt = Object.keys(response.data.carrier_lookup).length;
        if(this.autoCarrierLookupCnt > 0 && this.isAutoBound) {
          let bindDetails = sessionStorage.getItem('autoBindDetails') ? JSON.parse(sessionStorage.getItem('autoBindDetails')) : {};
          if (bindDetails && bindDetails.carrier_id) {
            this.selected_auto_carrier_id = bindDetails.carrier_id;
            if (bindDetails.quote_status === 'EBound') {
              let carrier_code = bindDetails.carrier_code;
              let AUQuoteId = JSON.parse(sessionStorage.getItem('autoSessionData')).SessionId; 
              let checkoutNav = `/pages/${carrier_code}Checkout/${AUQuoteId}`;
              let rc2PageName = carrier_code === 'bran' ? `${carrier_code}PolicyDetails` : `${carrier_code}ContactDetails`;
              let data = {"Navigate":`/pages/${rc2PageName}/${AUQuoteId}`};
              sessionStorage.setItem('autoRC1BindResponse', JSON.stringify(data));
              sessionStorage.setItem('checkoutNav', checkoutNav);
            }
          }
        }
      } else {
        this.hcarrierCount = response.data.carriers.length;
        this.homeCarrierLookupCnt = Object.keys(response.data.carrier_lookup).length;
        if(this.homeCarrierLookupCnt > 0 && this.isHomeBound) {
          
          let HOQuoteId = '';
          if (type === 'home') {
            let bindDetails = sessionStorage.getItem('homeBindDetails') ? JSON.parse(sessionStorage.getItem('homeBindDetails')) : {};
            if (bindDetails && bindDetails.carrier_id) {
              this.selected_home_carrier_id = bindDetails.carrier_id;
            }
          } else if (type === 'condo') {
            HOQuoteId = JSON.parse(sessionStorage.getItem('condoSessionData')).SessionId;
            let bindDetails = sessionStorage.getItem('homeBindDetails') ? JSON.parse(sessionStorage.getItem('homeBindDetails')) : {};
            if (bindDetails && bindDetails.carrier_id) {
              this.selected_home_carrier_id = bindDetails.carrier_id;
            }
          } else {
            HOQuoteId = JSON.parse(sessionStorage.getItem('renterSessionData')).SessionId;
            let bindDetails = sessionStorage.getItem('homeBindDetails') ? JSON.parse(sessionStorage.getItem('homeBindDetails')) : {};
            if (bindDetails && bindDetails.carrier_id) {
              this.selected_home_carrier_id = bindDetails.carrier_id;
            }
          }
        }
      }
      const carriers = response.data.carriers;
      // const carrierLookupCnt = Object.keys(response.data.carrier_lookup).length;
      const startTimeVal = (new Date()).getTime();
      for (let index = 0; index < carriers.length; index += 1) {
        axios.get(carriers[index])
          .then((singleCarrierResponse) => {
            if (singleCarrierResponse) { // Sarang mentioned this could come back as NULL
              for (let indexResults = 0; indexResults < singleCarrierResponse.data.length; indexResults += 1) {
                singleCarrierResponse.data[indexResults].carrierType = type;
                // if(type === 'auto') {
                //   singleCarrierResponse.data[indexResults].carrier_type = 'EZLYNXCARRIER';
                // }
                if((type === 'home' || type === 'renters' || type === 'condo' )&& this.selected_home_carrier_id === singleCarrierResponse.data[indexResults].carrier_id && this.isHomeBound) {
                  let bindDetails = sessionStorage.getItem('homeBindDetails') ? JSON.parse(sessionStorage.getItem('homeBindDetails')) : {};
                  if (bindDetails && bindDetails.quote_status && singleCarrierResponse.data[indexResults].carrier_type == null) {
                    singleCarrierResponse.data[indexResults].carrier_type = bindDetails.quote_status === 'EBound' ? 'RATECARRIER' : 'EZLYNXCARRIER';
                  }
                  this.$store.dispatch('setSelectedHomeCarrier', singleCarrierResponse.data[indexResults]);
                  sessionStorage.setItem('selectedCarrierHome', JSON.stringify(singleCarrierResponse.data[indexResults]));
                }
                if(type === 'auto' && this.selected_auto_carrier_id === singleCarrierResponse.data[indexResults].carrier_id && this.isAutoBound) {
                  let bindDetails = sessionStorage.getItem('autoBindDetails') ? JSON.parse(sessionStorage.getItem('autoBindDetails')) : {};
                  if (bindDetails && bindDetails.quote_status && singleCarrierResponse.data[indexResults].carrier_type == null) {
                    singleCarrierResponse.data[indexResults].carrier_type = bindDetails.quote_status === 'EBound' ? 'RATECARRIER' : 'EZLYNXCARRIER';
                  }
                  this.$store.dispatch('setSelectedAutoCarrier', singleCarrierResponse.data[indexResults]);
                  sessionStorage.setItem('selectedCarrierAuto', JSON.stringify(singleCarrierResponse.data[indexResults]));
                }
                switch (singleCarrierResponse.data[indexResults].status) {
                  case 'Success':
                    //below code is for PDF generation
                    let temp = {};
                    temp.carrier_id = singleCarrierResponse.data[indexResults].carrier_id;
                    temp.carrierType = type;
                    this.carriers.push(temp);
                    
                    this.carrierSuccessArray.push(singleCarrierResponse.data[indexResults]);
                    break;
                  case 'Error':
                    this.carrierErrorArray.push(singleCarrierResponse.data[indexResults]);
                    break;
                  default:
                  gtag('event', this.$store.getters.getSessionID, {
                  'event_label':JSON.stringify(singleCarrierResponse),
                  'event_category': 'RC1_Exception',
                  'value':JSON.stringify(singleCarrierResponse),
                  });
                }
              }
              this.filterArray('all');
            }
            this.updateProgressBar();
            if((index+1) === carriers.length) {
              common.gapRecordAnalytics(this.pageName);
              // log API response time through application into GA tool
              common.gapRecordAnalyticsGeneric(startTimeVal, 'API', this.pageName);
            }
          })
          .catch(() => {
            const serverErrorCarrierID = carriers[index].split('/')[2];
            const serverErrorCarrierInfo = response.data.carrier_lookup[serverErrorCarrierID][serverErrorCarrierID];

            if (serverErrorCarrierInfo) {
              const carrierName = serverErrorCarrierInfo.carrier_name;
              const logoPath = serverErrorCarrierInfo.logo_path;
              this.carrierErrorArray.push({ logo_path: logoPath, carrier_name: carrierName, status_message: `${carrierName} General Server Error` });
            } else if (serverErrorCarrierID === 'Ezlynx') {
              var ezObject = response.data.carrier_lookup['Ezlynx'];
              for (var key in ezObject) {
                if (ezObject.hasOwnProperty(key)) {
                  this.carrierErrorArray.push({ logo_path: ezObject[key].logo_path, carrier_name: ezObject[key].carrier_name, status_message: ezObject[key].carrier_name + ' General Server Error' });
                }
              }
            } else {
              this.carrierErrorArray.push({ logo_path: '', carrier_name: 'Carrier', status_message: 'General Server Error' });
            }

            this.updateProgressBar();
          });
      }
    },
    async callHomeStartBind(carDataHome, HOQuoteId) {
      if (this.isHomeBound) {
        return true;
      }
      //Home Bind Start
      let homeRC1BindResponse;
      let redUrlHome = '';
      for (let indexBtns = 0; indexBtns < carDataHome.buttons.length; indexBtns += 1) {
        if (carDataHome.buttons[indexBtns].name === 'SelectCarrierButton') {
          redUrlHome = carDataHome.buttons[indexBtns].on_click;
        }
      }
      /* start for patch call for carrier*/
      let requestParams = {
        url: `/quotes/${HOQuoteId}/startbind`,
        data : {
            "carrierId": carDataHome.carrier_id
          },
      };            
      
      /**
       * get navigation url after clicking on select carrier to continue RC2 flow
       */
       await patchData.patchApi(requestParams).then((response) => {
        homeRC1BindResponse = 'success';
        // if (response && response.data && response.data.Navigate) {
        //   homeRC1BindResponse = response.data;
        //   // sessionStorage.setItem('homeRC1BindResponse', JSON.stringify(response.data));
        //   // homeBindStatus = true;
        // }
      });
      if(homeRC1BindResponse) {
        return true
      }
      return false;
      //Home Bind End//
    },
    async callAutoStartBind(carDataAuto, AUQuoteId) {
      if (this.isAutoBound) {
        let autoRC1BindResponse = sessionStorage.getItem('autoRC1BindResponse') ? JSON.parse(sessionStorage.getItem('autoRC1BindResponse')) : false;
        return autoRC1BindResponse;
      }
      //Auto Bind Start//
      let autoRC1BindResponse;
      let redUrlAuto = '';
      for (let indexBtns = 0; indexBtns < carDataAuto.buttons.length; indexBtns += 1) {
        if (carDataAuto.buttons[indexBtns].name === 'SelectCarrierButton') {
          redUrlAuto = carDataAuto.buttons[indexBtns].on_click;
        }
      }
      const requestParamAuto = {
        url: redUrlAuto,
        data: {
          session_id: AUQuoteId,
          page_name: 'CarrierMatches',
        },
      };
      /**
       * get navigation url after clicking on select carrier to continue RC2 flow
       */
       await fetchData.fetchNavUrl(requestParamAuto).then((response) => {
        if (response && response.data && response.data.Navigate) {
          autoRC1BindResponse = response.data;
          sessionStorage.setItem('autoRC1BindResponse', JSON.stringify(response.data));
          // autoBindStatus = true;
        }
      });
      //Auto Bind End//
      if (autoRC1BindResponse) {
        return autoRC1BindResponse;
      }
      return false;
    },
    openRc2Flow() {
      if (this.flowType === 'bundle') {
        this.openHomeAutoRc2Flow();
      } else if (this.flowType === 'cabundle') {
        this.openCondoAutoRc2Flow();
      } else if (this.flowType === 'rabundle') {
        this.openRentersAutoRc2Flow();
      }
    },
    /**
     * Open a totally new and independent browser window with the specified URL.
     */
    async openHomeAutoRc2Flow() {
      let homeBindStatus = false;
      let autoBindStatus = {};

      let carDataHome = this.selectedHomeCarrier;
      let carDataAuto = this.selectedAutoCarrier;
      let externalUrlHome;
      let externalUrlAuto;
      let HOQuoteId = JSON.parse(sessionStorage.getItem('homeSessionData')).SessionId;
      let AUQuoteId = JSON.parse(sessionStorage.getItem('autoSessionData')).SessionId;
      if(carDataHome !== null) {
        externalUrlHome = carDataHome.external_url;
        //TODO::This is temporay fix for travelers we need to remove this code once we have rc2 flow ready
        if (externalUrlHome && !this.isHomeBound) {
          carDataHome.carrier_type = 'EZLYNXCARRIER';
          // await this.callHomeStartBind(carDataHome, HOQuoteId);
          let redUrl = '';
          for (let indexBtns = 0; indexBtns < carDataHome.buttons.length; indexBtns += 1) {
            if (carDataHome.buttons[indexBtns].name === 'SelectCarrierButton') {
              redUrl = carDataHome.buttons[indexBtns].on_click;
            }
          }
          console.log('redUrl===', redUrl);
          const requestParam = {
            url: redUrl,
            data : {
              session_id: HOQuoteId,
              page_name: 'HOCarrierMatches',
            },
          };
          await fetchData.fetchNavUrl(requestParam).then((response) => {
          });
        }
        sessionStorage.setItem('selectedCarrierHome', JSON.stringify(this.selectedHomeCarrier));
      }
      if(carDataAuto !== null) {
        externalUrlAuto = carDataAuto.external_url;
        //TODO::This is temporay fix for travelers we need to remove this code once we have rc2 flow ready
        if (externalUrlAuto) {
          carDataAuto.carrier_type = 'EZLYNXCARRIER';
          await this.callAutoStartBind(carDataAuto, AUQuoteId);
        }
        sessionStorage.setItem('selectedCarrierAuto', JSON.stringify(this.selectedAutoCarrier));
      }            

      //Only Home Carrier is selected
      if (this.selectedHomeCarrier && !this.selectedAutoCarrier) {
        if (this.selectedHomeCarrier.carrier_type === 'EZLYNXCARRIER') {
          sessionStorage.setItem('sessionData', sessionStorage.getItem('homeSessionData'));
          this.$store.dispatch('setSessionQuote', { SessionId: JSON.parse(sessionStorage.getItem('homeSessionData')).SessionId });
          this.$router.replace('/home/non-end-to-end');
        } else {
          autoBindStatus = true;
          homeBindStatus = await this.callHomeStartBind(carDataHome, HOQuoteId);
        }
      } else if (!this.selectedHomeCarrier && this.selectedAutoCarrier) {
        if (this.selectedAutoCarrier.carrier_type === 'EZLYNXCARRIER') {
          sessionStorage.setItem('sessionData', sessionStorage.getItem('autoSessionData'));
          let autoSessionId = JSON.parse(sessionStorage.getItem('autoSessionData')).SessionId;
          this.$store.dispatch('setSessionQuote', { SessionId: autoSessionId });
          this.$router.replace('/auto/non-end-to-end');
        } else {
          autoBindStatus = await this.callAutoStartBind(carDataAuto, AUQuoteId);
          if (!externalUrlAuto && autoBindStatus && autoBindStatus.Navigate) {
            // sessionStorage.setItem('currentNav', 'autorc2');
            this.$store.dispatch('setCurrentNav', autoBindStatus.Navigate);
            this.$router.replace(common.getRouteName(autoBindStatus.Navigate));
          }
        }
      } else if (this.selectedHomeCarrier && this.selectedAutoCarrier){
        if(this.selectedAutoCarrier.carrier_type === 'RATECARRIER' && this.selectedHomeCarrier.carrier_type === 'RATECARRIER') {
            homeBindStatus = await this.callHomeStartBind(carDataHome, HOQuoteId);
            autoBindStatus = await this.callAutoStartBind(carDataAuto, AUQuoteId);
        } else if (this.selectedAutoCarrier.carrier_type === 'EZLYNXCARRIER' && this.selectedHomeCarrier.carrier_type === 'RATECARRIER') {
          autoBindStatus = true;
          homeBindStatus = await this.callHomeStartBind(carDataHome, HOQuoteId);
        } else if (this.selectedHomeCarrier.carrier_type === 'EZLYNXCARRIER' && this.selectedAutoCarrier.carrier_type === 'EZLYNXCARRIER') {
          // sessionStorage.setItem('sessionData', sessionStorage.getItem('homeSessionData'));
          this.$router.replace('/auto/non-end-to-end');
        } else if (this.selectedHomeCarrier.carrier_type === 'EZLYNXCARRIER') {
          if (this.selectedAutoCarrier.carrier_type === 'RATECARRIER') {
            autoBindStatus = await this.callAutoStartBind(carDataAuto, AUQuoteId);
          }
          sessionStorage.setItem('sessionData', sessionStorage.getItem('homeSessionData'));
          this.$store.dispatch('setSessionQuote', { SessionId: JSON.parse(sessionStorage.getItem('homeSessionData')).SessionId });
          this.$router.replace('/home/non-end-to-end');
        }
      }
      console.log(homeBindStatus ,'&&', autoBindStatus)
      if(homeBindStatus && autoBindStatus) {
        if(!externalUrlHome) {
          let getUrl = `/pages/HORateCall2Details/${HOQuoteId}`;`/pages/HORateCall2Details/${HOQuoteId}`;
          sessionStorage.setItem('currentFlow', 'RC2');
          //Redirect to home rc2 first page
          this.$store.dispatch('setCurrentNav',getUrl);
          // sessionStorage.setItem('currentNav', 'homerc2');
          sessionStorage.setItem('currentRc2FromNav', 'carrier-matches');//TODO: Temporary logic as not getting value of this.routerInfo.from on page C:\DMS\dev\javaprojects\AgentPortaICOM\src\components\interview\propertyInsurance\SectionDisplayRcTwo.vue
          //change session data in storage
          this.$store.dispatch('setSessionQuote', { SessionId: HOQuoteId });
          sessionStorage.setItem('sessionData', sessionStorage.getItem('homeSessionData'));
          if (carDataHome.carrier_id !== 171) {
            this.$store.dispatch('sethomeRc2Nav','hodwelling', getUrl);
            sessionStorage.setItem('sethomeRc2Nav', 'hodwelling');
            sessionStorage.setItem('setRc2NavFlowAction', true);
            this.$store.dispatch('setRc2NavFlowAction', true);
            this.$router.replace(common.getRouteName(getUrl));
          } else {
            const rateRequestParams = {
              url: `/pages/horatecall2details/${HOQuoteId}`,
            };
            fetchData.getPageData(rateRequestParams).then((response) => { 
              this.pageData = response.data;
              this.pageFieldsArray = this.pageData.fields;
              if (this.pageFieldsArray.some(field => field.section === 'Primary Mortgage' && field.visible)) {
                this.$store.dispatch('sethomeRc2Nav','homortgage');
                sessionStorage.setItem('sethomeRc2Nav', 'homortgage');
                sessionStorage.setItem('setRc2NavFlowAction', true);
                this.$store.dispatch('setRc2NavFlowAction', true);
                sessionStorage.setItem("mortgagehighlight",true);
                this.$router.replace('/home/mortgage');
              }else{
                this.$store.dispatch('sethomeRc2Nav','hocoverage');
                sessionStorage.setItem('sethomeRc2Nav', 'hocoverage');
                sessionStorage.setItem('setRc2NavFlowAction', true);
                this.$store.dispatch('setRc2NavFlowAction', true);
                sessionStorage.setItem("mortgagehighlight",false);
                this.$router.replace('/home/coverage');
              }
            });             
          }
        }
      }
    },
    /**
     * Open a totally new and independent browser window with the specified URL.
     */
    async openCondoAutoRc2Flow() {
      // let homeBindStatus = false;
      let autoBindStatus = {};

      let carDataHome = this.selectedHomeCarrier;
      let carDataAuto = this.selectedAutoCarrier;
      let externalUrlHome;
      let externalUrlAuto;
      let COQuoteId = JSON.parse(sessionStorage.getItem('condoSessionData')).SessionId;
      let AUQuoteId = JSON.parse(sessionStorage.getItem('autoSessionData')).SessionId;
      if(carDataHome !== null) {
        externalUrlHome = carDataHome.external_url;
        //TODO::This is temporay fix for travelers we need to remove this code once we have rc2 flow ready
        if (externalUrlHome && !this.isHomeBound) {
          carDataHome.carrier_type = 'EZLYNXCARRIER';
          // await this.callHomeStartBind(carDataHome, HOQuoteId);
          let redUrl = '';
          for (let indexBtns = 0; indexBtns < carDataHome.buttons.length; indexBtns += 1) {
            if (carDataHome.buttons[indexBtns].name === 'SelectCarrierButton') {
              redUrl = carDataHome.buttons[indexBtns].on_click;
            }
          }
          console.log('redUrl===', redUrl);
          const requestParam = {
            url: redUrl,
            data : {
              session_id: COQuoteId,
              page_name: 'COCarrierMatches',
            },
          };
          await fetchData.fetchNavUrl(requestParam).then((response) => {
          });
        }
        sessionStorage.setItem('selectedCarrierHome', JSON.stringify(this.selectedHomeCarrier));
      }
      if(carDataAuto !== null) {
        externalUrlAuto = carDataAuto.external_url;
        //TODO::This is temporay fix for travelers we need to remove this code once we have rc2 flow ready
        if (externalUrlAuto) {
          carDataAuto.carrier_type = 'EZLYNXCARRIER';
          await this.callAutoStartBind(carDataAuto, AUQuoteId);
        }
        sessionStorage.setItem('selectedCarrierAuto', JSON.stringify(this.selectedAutoCarrier));
      }            

      //Only Home Carrier is selected
      if (this.selectedHomeCarrier && !this.selectedAutoCarrier) {
        if (this.selectedHomeCarrier.carrier_type === 'EZLYNXCARRIER') {
          sessionStorage.setItem('sessionData', sessionStorage.getItem('condoSessionData'));
          this.$store.dispatch('setSessionQuote', { SessionId: JSON.parse(sessionStorage.getItem('condoSessionData')).SessionId });
          this.$router.replace('/condo/non-end-to-end');
        } else {
          // autoBindStatus = true;
          // homeBindStatus = await this.callHomeStartBind(carDataHome, HOQuoteId);
        }
      } else if (!this.selectedHomeCarrier && this.selectedAutoCarrier) {
        if (this.selectedAutoCarrier.carrier_type === 'EZLYNXCARRIER') {
          sessionStorage.setItem('sessionData', sessionStorage.getItem('autoSessionData'));
           this.$store.dispatch('setSessionQuote', { SessionId: JSON.parse(sessionStorage.getItem('autoSessionData')).SessionId });
          this.$router.replace('/auto/non-end-to-end');
        } else {
          autoBindStatus = await this.callAutoStartBind(carDataAuto, AUQuoteId);
          if (!externalUrlAuto && autoBindStatus && autoBindStatus.Navigate) {
            // sessionStorage.setItem('currentNav', 'autorc2');
            this.$store.dispatch('setCurrentNav', autoBindStatus.Navigate);
            this.$router.replace(common.getRouteName(autoBindStatus.Navigate));
          }
        }
      } else if (this.selectedHomeCarrier && this.selectedAutoCarrier){
        if(this.selectedAutoCarrier.carrier_type === 'RATECARRIER' && this.selectedHomeCarrier.carrier_type === 'RATECARRIER') {
            // homeBindStatus = await this.callHomeStartBind(carDataHome, HOQuoteId);
            // autoBindStatus = await this.callAutoStartBind(carDataAuto, AUQuoteId);
        } else if (this.selectedAutoCarrier.carrier_type === 'EZLYNXCARRIER' && this.selectedHomeCarrier.carrier_type === 'RATECARRIER') {
          // autoBindStatus = true;
          // homeBindStatus = await this.callHomeStartBind(carDataHome, HOQuoteId);
        } else if (this.selectedHomeCarrier.carrier_type === 'EZLYNXCARRIER' && this.selectedAutoCarrier.carrier_type === 'EZLYNXCARRIER') {
          // sessionStorage.setItem('sessionData', sessionStorage.getItem('condoSessionData'));
          //  this.$store.dispatch('setSessionQuote', { SessionId: JSON.parse(sessionStorage.getItem('condoSessionData')).SessionId });
          this.$router.replace('/auto/non-end-to-end');
        } else if (this.selectedHomeCarrier.carrier_type === 'EZLYNXCARRIER') {
          if (this.selectedAutoCarrier.carrier_type === 'RATECARRIER') {
            autoBindStatus = await this.callAutoStartBind(carDataAuto, AUQuoteId);
          }
          sessionStorage.setItem('sessionData', sessionStorage.getItem('condoSessionData'));
           this.$store.dispatch('setSessionQuote', { SessionId: JSON.parse(sessionStorage.getItem('condoSessionData')).SessionId });
          this.$router.replace('/condo/non-end-to-end');
        }
      }
    },    
    /**
     * Open a totally new and independent browser window with the specified URL.
     */
     async openRentersAutoRc2Flow() {
      // let homeBindStatus = false;
      let autoBindStatus = {};

      let carDataHome = this.selectedHomeCarrier;
      let carDataAuto = this.selectedAutoCarrier;
      let externalUrlHome;
      let externalUrlAuto;
      let RAQuoteId = JSON.parse(sessionStorage.getItem('renterSessionData')).SessionId;
      let AUQuoteId = JSON.parse(sessionStorage.getItem('autoSessionData')).SessionId;
      if(carDataHome !== null) {
        externalUrlHome = carDataHome.external_url;
        //TODO::This is temporay fix for travelers we need to remove this code once we have rc2 flow ready
        if (externalUrlHome && !this.isHomeBound) {
          carDataHome.carrier_type = 'EZLYNXCARRIER';
          // await this.callHomeStartBind(carDataHome, HOQuoteId);
          let redUrl = '';
          for (let indexBtns = 0; indexBtns < carDataHome.buttons.length; indexBtns += 1) {
            if (carDataHome.buttons[indexBtns].name === 'SelectCarrierButton') {
              redUrl = carDataHome.buttons[indexBtns].on_click;
            }
          }
          console.log('redUrl===', redUrl);
          const requestParam = {
            url: redUrl,
            data : {
              session_id: RAQuoteId,
              page_name: 'RECarrierMatches',
            },
          };
          await fetchData.fetchNavUrl(requestParam).then((response) => {
          });
        }
        sessionStorage.setItem('selectedCarrierHome', JSON.stringify(this.selectedHomeCarrier));
      }
      if(carDataAuto !== null) {
        externalUrlAuto = carDataAuto.external_url;
        //TODO::This is temporay fix for travelers we need to remove this code once we have rc2 flow ready
        if (externalUrlAuto) {
          carDataAuto.carrier_type = 'EZLYNXCARRIER';
          await this.callAutoStartBind(carDataAuto, AUQuoteId);
        }
        sessionStorage.setItem('selectedCarrierAuto', JSON.stringify(this.selectedAutoCarrier));
      }            

      //Only Home Carrier is selected
      if (this.selectedHomeCarrier && !this.selectedAutoCarrier) {
        if (this.selectedHomeCarrier.carrier_type === 'EZLYNXCARRIER') {
          sessionStorage.setItem('sessionData', sessionStorage.getItem('renterSessionData'));
           this.$store.dispatch('setSessionQuote', { SessionId: JSON.parse(sessionStorage.getItem('renterSessionData')).SessionId });
          this.$router.replace('/renters/non-end-to-end');
        } else {
          // autoBindStatus = true;
          // homeBindStatus = await this.callHomeStartBind(carDataHome, HOQuoteId);
        }
      } else if (!this.selectedHomeCarrier && this.selectedAutoCarrier) {
        if (this.selectedAutoCarrier.carrier_type === 'EZLYNXCARRIER') {
          sessionStorage.setItem('sessionData', sessionStorage.getItem('autoSessionData'));
          this.$store.dispatch('setSessionQuote', { SessionId: JSON.parse(sessionStorage.getItem('autoSessionData')).SessionId });
          this.$router.replace('/auto/non-end-to-end');
        } else {
          autoBindStatus = await this.callAutoStartBind(carDataAuto, AUQuoteId);
          if (!externalUrlAuto && autoBindStatus && autoBindStatus.Navigate) {
            // sessionStorage.setItem('currentNav', 'autorc2');
            this.$store.dispatch('setCurrentNav', autoBindStatus.Navigate);
            this.$router.replace(common.getRouteName(autoBindStatus.Navigate));
          }
        }
      } else if (this.selectedHomeCarrier && this.selectedAutoCarrier){
        if(this.selectedAutoCarrier.carrier_type === 'RATECARRIER' && this.selectedHomeCarrier.carrier_type === 'RATECARRIER') {
            // homeBindStatus = await this.callHomeStartBind(carDataHome, HOQuoteId);
            // autoBindStatus = await this.callAutoStartBind(carDataAuto, AUQuoteId);
        } else if (this.selectedAutoCarrier.carrier_type === 'EZLYNXCARRIER' && this.selectedHomeCarrier.carrier_type === 'RATECARRIER') {
          // autoBindStatus = true;
          // homeBindStatus = await this.callHomeStartBind(carDataHome, HOQuoteId);
        } else if (this.selectedHomeCarrier.carrier_type === 'EZLYNXCARRIER' && this.selectedAutoCarrier.carrier_type === 'EZLYNXCARRIER') {
          // sessionStorage.setItem('sessionData', sessionStorage.getItem('renterSessionData'));
          this.$router.replace('/auto/non-end-to-end');
        } else if (this.selectedHomeCarrier.carrier_type === 'EZLYNXCARRIER') {
          if (this.selectedAutoCarrier.carrier_type === 'RATECARRIER') {
            autoBindStatus = await this.callAutoStartBind(carDataAuto, AUQuoteId);
          }
          sessionStorage.setItem('sessionData', sessionStorage.getItem('renterSessionData'));
           this.$store.dispatch('setSessionQuote', { SessionId: JSON.parse(sessionStorage.getItem('renterSessionData')).SessionId });
          this.$router.replace('/renters/non-end-to-end');
        }
      }
    },
  },
  created() {
    this.flowType = sessionStorage.getItem('flowType');    
    this.sessionID = '';
    this.flow = '';
    let page_name;
    if (this.flowType === 'bundle') {
      this.flow = 'home';
      this.sessionID = JSON.parse(sessionStorage.getItem('homeSessionData')).SessionId; 
      page_name = 'hocarriermatches';       
    } else if (this.flowType === 'cabundle') {
      this.flow = 'condo';
      this.sessionID = JSON.parse(sessionStorage.getItem('condoSessionData')).SessionId;
      page_name = 'cocarriermatches';
    } else if (this.flowType === 'rabundle') {
      this.flow = 'renters';
      this.sessionID = JSON.parse(sessionStorage.getItem('renterSessionData')).SessionId;
      page_name = 'recarriermatches';
    }
    if (this.isHomeBound && !sessionStorage.getItem('homeBindDetails')) {
      const rateRequestParams = {
        url: `/pages/${page_name}/${this.sessionID}`,
      };
      fetchData.getPageData(rateRequestParams).then((response) => {
        if (response.data.quote_summary.binding_carrier) {
          //Store bind quote details in session storage for bundle quote
          let bindDetails = {
            'quote_status' : response.data.quote_summary.binding_carrier.carrier_real_bind_indicator === true ? 'EBound' : 'NEBound',
            'carrier_id' : response.data.quote_summary.binding_carrier.carrier_id,
            'carrier_code' : response.data.quote_summary.binding_carrier.carrier_code,
            'quote_bind_type' : response.data.quote_summary.binding_carrier.quote_bind_type,
          }
          sessionStorage.setItem('homeBindDetails', JSON.stringify(bindDetails));
        }
      })
    }
    //Adding check if user come on this page from direct url without filling each pages
     const storedPageName=sessionStorage.getItem('navUrl').split("/");
     axios.post(
          `/navs/CarrierMatches`,// API endpoint URL
          {
          fields: '', // All of the current `pageData` fields
          page_name: storedPageName[2], // Current `pageData` `page_name`
          session_id: this.$store.getters.getSessionID, // Current Session ID
        },
    ).then((response) => {
      if(response.data.Navigate.includes('CarrierMatches'))
    {
    /* Call page data API first and then start looking for rates */
    const requestParam = {
      url: this.$store.getters.getNavLink,
    };

    /**
     * Below is where we utilize our 'import fetchData' to get ALL the data except Successful/Unsuccessful
     * carrier information needed to render this page:
     * contents of Help/Script and Quote Summary, State of the navigation buttons, etc.
     */
    fetchData.getPageData(requestParam).then((response) => {
      this.pageData = response.data;
      this.pageName = response.data.page_name;
      this.pageFieldsArray = this.pageData.fields;
      if((this.flowType === 'bundle' || this.flowType === 'cabundle'  || this.flowType === 'rabundle') && this.isPolicyBound()) {
        sessionStorage.setItem('autobound', true);
        if (response.data.quote_summary.binding_carrier) {
          //Store bind quote details in session storage for bundle quote
          let bindDetails = {
            'quote_status' : response.data.quote_summary.binding_carrier.carrier_real_bind_indicator === true ? 'EBound' : 'NEBound',
            'carrier_id' : response.data.quote_summary.binding_carrier.carrier_id,
            'carrier_code' : response.data.quote_summary.binding_carrier.carrier_code,
            'quote_bind_type' : response.data.quote_summary.binding_carrier.quote_bind_type,
          }
          sessionStorage.setItem('autoBindDetails', JSON.stringify(bindDetails));
        }
      }
      /* collect blurb data in blurbs array based on position */
      for (let blurb = 0; blurb < this.pageData.blurbs.length; blurb += 1) {
        if (!this.blurbs[this.pageData.blurbs[blurb].location]) {
          this.blurbs[this.pageData.blurbs[blurb].location] = [];
        }
        this.blurbs[this.pageData.blurbs[blurb].location].visible = this.pageData.blurbs[blurb].visible;
        this.blurbs[this.pageData.blurbs[blurb].location].content = this.pageData.blurbs[blurb].content;
      }
      /* blurb data collection ends here */
      /* Page API Call ends here */
      
      /* HOME Rate call rates API start here */
      const apiURL = `/carriers/${this.sessionID}`;
      /**
       * Our Call to retrieve different rates for all carriers
       */
      fetchData.getCarriersData(apiURL).then((response2) => {
        this.lastRC1DateTimeString=response2.data.lastRC1DateTimeString;
        this.showProgressBar = true;
        this.processCarriersMultipleCalls(response2, this.flow);
        this.isHomeCallComplete = true;
      });
      /* HOME Rate call rates API End Here*/
    
      /* AUTO Rate call rates API start here */
      const AUQuoteId = JSON.parse(sessionStorage.getItem('autoSessionData')).SessionId;//this.$store.getters.getSessionID;
      const AutoUrl = `/carriers/${AUQuoteId}`;

      /**
       * Our Call to retrieve different rates for all carriers
       */
      fetchData.getCarriersData(AutoUrl).then((response2) => {
        this.lastRC1DateTimeStringAuto=response2.data.lastRC1DateTimeString;
        this.showProgressBar = true;
        this.processCarriersMultipleCalls(response2, 'auto');
        this.isAutoCallComplete = true;
        if(this.lastRC1DateTimeString !=='')
        { 
         const latestDatetimeHome= new Date(this.lastRC1DateTimeString.replace('PT', ''));
         const latestDatetimeAuto=new Date(this.lastRC1DateTimeStringAuto.replace('PT', ''));
         if(latestDatetimeHome.getTime() > latestDatetimeAuto.getTime())
          {
           this.lastRC1DateTimeString=this.lastRC1DateTimeString;
          }
          else
          this.lastRC1DateTimeString=this.lastRC1DateTimeStringAuto;
        }
        else
        this.lastRC1DateTimeString=this.lastRC1DateTimeStringAuto;
       });
     /* AUTO Rate call rates API End Here*/
    });
     }
    else 
      {
      this.$store.dispatch('setCurrentNav', response.data.Navigate);
      this.$router.replace(common.getRouteName(response.data.Navigate));
      }
      }).catch((error) => {
        // TODO: Use response (data or http code) to evaluate error
        window.console.warn('An error occurred while requesting a section button post:', error);
        gtag('event', 'exception', {
          description: 'Error requesting section button quote',
          fatal: false, // set to true if the error is fatal
        });
      });   
  },
  mounted() {
    /* eslint no-undef: */
    /* eslint prefer-template:  */
     this.$store.dispatch('setSelectedAutoCarrier', null);
     this.$store.dispatch('setSelectedHomeCarrier', null);
     sessionStorage.removeItem('selectedCarrierAuto');
     sessionStorage.removeItem('selectedCarrierHome');
     sessionStorage.removeItem('autoRC1BindResponse');
     sessionStorage.removeItem('pdfLinkCov');
     sessionStorage.removeItem('homePdfLinkCov');
  },
};
</script>
<style lang="scss">
  .smaller-text-secondary 
{
  color: $var-text-secondary;
  font-size: 10px;
}
  .export-dropdown-col .btn-group.btn-group-toggle {
    width: 80%;
    position: relative;
    right: -56px;
  }
  .quote-panel-open .export-dropdown-col .btn-group.btn-group-toggle {
    right: -46px;
  }
  .export-dropdown-col .dropdown.single {
    width: 100%;
  }
  .export-dropdown-col .dropdown-menu {
    width: 100% !important;
  }
  .vs__selected-options input::placeholder{
    color: #1A1A1A !important;
  }
</style>
<style scoped lang="scss">
.disabled.bound-carrier {
    pointer-events: none;
    cursor: not-allowed;
    opacity: 0.35;
}
.b-alert-warning {
  font-size: 12px;
}
.blank-space{
  height: 200px;
}
.same-carrier-bundle-discount {
  color: #000000;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}
.icon-star{
  color: #FF4400;
}
.quote-panel-close {
  margin-top: 9.5em;
}
/***Results Header***/
#results-table .selected, #results-table .selected:hover{
  color: #FFFFFF !important;
  background: $var-color-home-auto-bundle !important;
}

.progress-bar-bg {
  background-color: $var-success-green !important;
}

#results-table .selected:hover{
  cursor: pointer;
}

/********************************
#results-table .col-head:hover {
  background: #EEEEEE;
}
********************************/

#results-table .col-head{
   padding: 0.5rem;
   text-align: center;
   color: $var-input-icon-color;
   cursor: pointer;
   border-radius: 0.25rem 0.25rem 0 0;
 }

/***Progress Bar***/
.progress{
  height: 1.5rem;
}

.bg-greyed {
  background-color: $var-color-grey-knockout;
}

.border-bottom-carriers {
  border-bottom: 10px solid $var-color-home-auto-bundle !important;
}
.select-dropbox {
  padding: 4px 84px 4px 8px;
  border-radius: 4px;
  border: 1px solid #CCCCCC;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  background: #fff url("data:image/svg+xml,%3Csvg width='20' height='15' viewBox='0 0 15 5' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath id='Vector' d='M7.20593 7.78781L0.975371 1.92106C0.674876 1.63811 0.674876 1.17938 0.975371 0.896463L1.70207 0.212204C2.00205 -0.0702607 2.48823 -0.0708043 2.78892 0.210996L7.75002 4.8605L12.7111 0.210996C13.0118 -0.0708043 13.498 -0.0702607 13.7979 0.212204L14.5246 0.896463C14.8251 1.17941 14.8251 1.63814 14.5246 1.92106L8.2941 7.78781C7.99361 8.07073 7.50643 8.07073 7.20593 7.78781Z' fill='%23949494'/%3E%3C/svg%3E%0A") right 9px center/12px 10px no-repeat !important;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
}

.quote-panel-open .page-wrap{
  margin-top: 9em !important;
}
/***content top margin breakpoints - adjusts for navigation stacks***/
@media all and (max-width: 1372px) {
  .page-wrap {
    margin-top: 70px;
  }
}
@media all and (min-width: 1371px) {
  .page-wrap {
    margin-top: 35px;
  }
}
.appt-error-msg{
  color: #BB0000;
  font-size: 1.5rem;
  margin-bottom: 40%;
}
#results-head a:hover{
  text-decoration: none !important;
}
//Here is bundle css
.bundle-carrier-logo {
  img{
    // height: 30px;
    width: 113px;
  }
  .bundle-coverage-text{
    border-left: 1px solid #CCC;
    color: #000;
    font-size: 12px;
    // font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    line-height: 32px;
    height: 32px;
    display: inline-block;
  }
}
.bundle-carrier-premium{
  color: #1A1A1A;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  span {
    font-weight: 400;
    color:#333333;
    font-size: 12px;
    &.line-through{
      text-decoration: line-through;
    }
    &.save {
      font-weight: 700;
      color: #4F7D7D;
    }
  }
  &.total{
    font-size: 20px;
  }
  &.discounted span.quoteTerm{
    display: block;
    font-size: 14px;
    span {
      font-size: 14px;
    }
  }
}
.selected-carrier-bottom-container{
  position: fixed;
  bottom: 0;
  left: -15px;
  border-top: 1px solid #CCCCCC;
  width: 102%;
  background: #F9F9F9;
  &.margin-25 {
    width: 77%;
    -webkit-transition: width 500ms;
    transition: width 500ms;
  }
  
  #select-carrier-btn{
    background: $var-color-home-auto-bundle;
  }
  #select-carrier-btn:hover{
    background: #FFFFFF;
  }
}
.btn-primary.refreshButton {
  background-color: #FFFFFF;
  border-color:  $var-color-home-auto-bundle;
  color: $var-color-home-icon;

  &:hover {
    background-color: $var-color-home-auto-bundle;
    border-color: #FFFFFF;
    color: #FFFFFF;
  }
}
.summary-col {
  p:first-child {
    color: #1A1A1A;
    // font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 30px;
  }
  p{
    color: #595959;
    // font-family: Roboto;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    text-align: left;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/interview/shared/CarrierMatches.vue?1d355fe2